import React, { useEffect, useCallback, useState} from 'react';
import VarzUX from "components/zobject/custom/VarzUX.js";
import {connect} from 'react-redux';

const VarzComponent = ({zobject, pattr, planeMapping, containerRef}) => { 
    return (<VarzUX
              planeMapping={planeMapping}
              zobject={zobject} pattr={pattr} containerRef={containerRef}/>);
}

const mapStateToProps = (state, props) => {
  return {
        planeMapping: state.effects.planeMapping,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VarzComponent);
